import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-mesafeli-satis-sozlesmesi',
  templateUrl: './mesafeli-satis-sozlesmesi.page.html',
  styleUrls: ['./mesafeli-satis-sozlesmesi.page.scss'],
})
export class MesafeliSatisSozlesmesiPage implements OnInit {

  constructor(private modalController: ModalController) { }

  ngOnInit() {
  }

  dismiss() {
    this.modalController.dismiss();
  }


}
